import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"position":"relative"} }
const _hoisted_2 = {
  class: "google-map",
  ref: "googleMap"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MapControls = _resolveComponent("MapControls")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, null, 512),
    (_ctx.map && _ctx.showControls)
      ? (_openBlock(), _createBlock(_component_MapControls, {
          key: 0,
          ref: "mapControls",
          map: _ctx.map,
          mapContainer: _ctx.$refs.googleMap,
          position: _ctx.position,
          labelsEnabled: _ctx.labelsEnabled,
          streetViewControlEnabled: _ctx.streetViewControlEnabled,
          navigationControlEnabled: true
        }, null, 8, ["map", "mapContainer", "position", "labelsEnabled", "streetViewControlEnabled"]))
      : _createCommentVNode("", true)
  ]))
}